
window.onload = function (e) {
  
    fetch("https://wtfismyip.com/json")
        .then((e) => e.json())
        .then((e) => {
     
            var t = e.YourFuckingLocation.replace(", Brazil", "");
      
             let prazo = moment().utcOffset('-0300').add(5, 'days').format("DD/MMMM");
            
      
      
      
            if(t == "Salvador, BA"){
              prazo = moment().utcOffset('-0300').add(3, 'days').format("DD/MMMM");
            }	
      
      
      //<a href='https://www.legboxbrasil.com.br/pages/previsao-entrega'>Saiba mais</a>
      
            prazo = prazo.replace("/"," de ");
            
                document.getElementsByClassName("shipping-preview-loading")[0].parentNode.removeChild(document.getElementsByClassName("shipping-preview-loading")[0])           
                document.getElementsByClassName("shipping-estimated")[0].insertAdjacentHTML("afterbegin", "Receba em <strong>" + t + "</strong> até " + prazo + ".");
        })
        .catch((e) => {
            throw e;
        });
};
